import { render, staticRenderFns } from "./exchangeDetails.vue?vue&type=template&id=40e4988e&scoped=true&"
import script from "./exchangeDetails.vue?vue&type=script&lang=js&"
export * from "./exchangeDetails.vue?vue&type=script&lang=js&"
import style0 from "./exchangeDetails.vue?vue&type=style&index=0&id=40e4988e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4988e",
  null
  
)

export default component.exports